import { Injectable } from '@angular/core';

import { TranslatorService } from './translator.service';

@Injectable()
export class TablesService {

  constructor(private readonly translatorService: TranslatorService) {

  }

  getMessages(): any {
    return {
      emptyMessage: this.translatorService.trans('table.no_data_display'),
      totalMessage: 'Total'
    };
  }

}
